import * as React from "react";

const MoonIcon = (props) => (
  <svg width={12} height={12} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M6 0c1.516 0 2.925.566 3.978 1.523A3.979 3.979 0 0 0 8 1a4.014 4.014 0 0 0-2.821 1.179A3.927 3.927 0 0 0 4 5c0 1.095.463 2.105 1.179 2.821A3.927 3.927 0 0 0 8 9a4.034 4.034 0 0 0 3.974-3.548c.017.18.026.364.026.548a6.02 6.02 0 0 1-1.768 4.232A6.02 6.02 0 0 1 6 12a5.89 5.89 0 0 1-4.232-1.768A6.02 6.02 0 0 1 0 6a5.89 5.89 0 0 1 1.768-4.232A6.02 6.02 0 0 1 6 0z"
      fill="#FFF"
    />
  </svg>
);

export default MoonIcon;
